import { createContext } from 'react';
import type { SessionUser } from '@wineryxplorer/shared';

export interface AuthContextType {
  user: SessionUser | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  /**
   * True while `user.getMe` is failing for a reason other than a genuine 401 —
   * the API is down, unreachable, or erroring. The session is intentionally
   * kept in this state; the provider keeps retrying until the API answers.
   */
  isApiUnreachable: boolean;
  refetchUser: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
